import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/page-components/Blog/Article/Article.tsx");
